import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73d5af79&scoped=true"
import script from "./askQuestionBlock.js?vue&type=script&lang=js&external"
export * from "./askQuestionBlock.js?vue&type=script&lang=js&external"
import style0 from "./styles.scss?vue&type=style&index=0&id=73d5af79&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d5af79",
  null
  
)

export default component.exports